import { Component, OnInit } from "@angular/core";
import {
  BidResponse,
  EnergySummary,
  UserUtilityListResponse,
  UserUtilityResponse,
} from "../../../interfaces/responses/models";
import { EnergySummaryService } from "../../../services/energy-summary.service";
import { Router } from "@angular/router";
import { BidService } from "../../../services/bids.service";
import { ScreenSizeService } from "../../../services/screen-size.service";
import { LocalStorageService } from "../../../services/local-storage.service";
import { BidRoundType } from "../../../interfaces/enums";
import { AuthService } from "src/app/services/auth.service";
import { DataService } from "src/app/services/data.service";

@Component({
  selector: "app-market",
  templateUrl: "./market.component.html",
  styleUrls: ["./market.component.css"],
})
export class MarketComponent implements OnInit {
  bidCategories: BidRoundType[] = Object.values(BidRoundType); // List of bid categories
  activeBid: BidResponse | null = null;
  error: string | null = null;
  energy: EnergySummary = {
    total_purchased: { total_energy: 0, avg_price: 0 },
    total_purchased_week: { total_energy: 0, avg_price: 0 },
    total_sold: { total_energy: 0, avg_price: 0 },
    total_sold_week: { total_energy: 0, avg_price: 0 },
    total_platform_purchased: { total_energy: 0, avg_price: 0 },
  };
  isMobile: boolean = false;
  role: string | null = null;
  userUtilityData: UserUtilityResponse[] = [];
  buy: boolean;
  sell: boolean;

  constructor(
    private bidService: BidService,
    private router: Router,
    private energyService: EnergySummaryService,
    private screenSizeService: ScreenSizeService,
    private localStorageService: LocalStorageService,
    private dataService: DataService,
    private authService: AuthService
  ) {}

  navigateTo(path: string) {
    this.router.navigate([path]);
  }

  ngOnInit(): void {
    const { buy, sell } = this.localStorageService.getPermissions();
    this.buy = buy;
    this.sell = sell;

    this.getEnergySummary();
    this.getActiveRegularBid();
    this.getUserUtilityConfiguration();

    this.role = this.localStorageService.getRole();

    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  getUserUtilityConfiguration() {
    this.authService
      .getUserUtilityConfiguration()
      .subscribe((data: UserUtilityListResponse) => {
        this.userUtilityData = data.items;
        // console.log(this.userUtilityData);
      });
  }

  getActiveRegularBid(): void {
    this.bidService.getActiveOpenBid().subscribe((response) => {
      if (
        response &&
        (response.bid_type === "Day ahead" ||
          response.bid_type === "Monthly") &&
        response.status != "CANCELLED"
      ) {
        this.activeBid = response;
      }
    });
  }

  getEnergySummary() {
    this.energyService.getEnergySummary().subscribe((data) => {
      this.energy = data;
    });
  }

  navigateToBidRound(): void {
    if (this.activeBid) {
      this.navigateTo(`/strike/${this.activeBid.id}`);
    }
  }
}
